export default "__VITE_ASSET__BXgSVYnc__"